import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft, Home, LayoutDashboard } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";

export default function NotFoundPage() {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const homePath = isAuthenticated ? "/dashboard" : "/";

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F8F9FA] px-4 py-12">
      <div className="w-full max-w-md text-center">
        <p
          className="select-none text-5xl font-semibold tracking-tight text-slate-300 sm:text-6xl"
          aria-label="Error 404"
        >
          404
        </p>
        <h1 className="mt-4 font-heading text-2xl font-semibold text-slate-900">Page not found</h1>
        <p className="mt-2 text-sm text-slate-600 sm:text-base">
          This page may have been moved, renamed, or never existed.
        </p>

        <div className="mt-8 flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center">
          <Button
            variant="outline"
            size="lg"
            className="w-full sm:w-auto"
            onClick={() => navigate(-1)}
          >
            <ArrowLeft className="mr-2 h-4 w-4" />
            Go back
          </Button>
          <Button asChild size="lg" className="w-full sm:w-auto">
            <Link to={homePath}>
              {isAuthenticated ? (
                <LayoutDashboard className="mr-2 h-4 w-4" />
              ) : (
                <Home className="mr-2 h-4 w-4" />
              )}
              {isAuthenticated ? "Go to dashboard" : "Back to home"}
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
}
